import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/services/admin.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  standalone: false,
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm!: FormGroup;
  email = new FormControl('', [Validators.email, Validators.required]);
  submitted = false;
  linkGenerated = false;
  dataLoaded = false;
  ecosystemLinks = environment.ecosystemUrls;

  constructor(
    private adminServ: AdminService,
    private toast: ToastrService,
    private _fb: FormBuilder
  ) {}

  ngOnInit(): void {
    const savedMode = localStorage.getItem('darkMode') === 'true';
    if (savedMode) {
      document.body.classList.add('dark-theme');
    }
    this.createForm();
  }

  createForm() {
    this.forgotPasswordForm = this._fb.group({
      email: ['', [Validators.email, Validators.required]],
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.forgotPasswordForm.valid) {
      this.dataLoaded = true;
      this.adminServ.forgotPass(this.forgotPasswordForm.value).subscribe({
        next: res => {
          this.dataLoaded = false;
          this.linkGenerated = true;
          this.toast.success(res.message);
        },
        error: err => {
          this.dataLoaded = false;
          this.toast.error(err?.error?.message || 'Failed to send reset link');
        },
      });
    }
  }
}

